import { render, staticRenderFns } from "./ScrimButtons.vue?vue&type=template&id=a88c0270&scoped=true&"
import script from "./ScrimButtons.vue?vue&type=script&lang=js&"
export * from "./ScrimButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88c0270",
  null
  
)

export default component.exports